import React, { useEffect, useState } from "react";
import { Typography } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  getInvestorDetailsByOrgId,
  sendOtp,
} from "../../../redux/slices/ProfileSlice";
import Loader from "../../../components/CustomLoader/Loader";
import {
  maskEmail,
  maskPhone,
  capitalizeWords,
} from "../../../helpers/helpers";
import CustomModal from "../../../components/CustomModal/CustomModal";
import OtpContent from "../../../components/OtpContent/OtpContent";
import NewEmailPhoneContent from "../../../components/NewEmailPhoneContent/NewEmailPhoneContent";
import EditDropdownsForm from "./EditDropdownsForm";
import ProfileDetail from "../../../components/Details/ProfileDetail";
import {
  GLOBAL_CONSTANTS,
  TITLE_TXT,
  USERTYPE_ID,
} from "../../../constants/constants";

const { Title } = Typography;

const CompanyDetails = () => {
  const { user } = useSelector((state) => state.auth);
  const { investorData, loading } = useSelector((state) => state.profile);
  const dispatch = useDispatch();
  const [showEmail, setShowEmail] = useState(false);
  const [showPhone, setShowPhone] = useState(false);
  const [oldDetailOtpModalOpen, setOldDetailOtpModalOpen] = useState(false);
  const [newDetailModalOpen, setNewDetailModalOpen] = useState(false);
  const [newDetailOtpModalOpen, setNewDetailOtpModalOpen] = useState(false);
  const [isMobileOtp, setIsMobileOtp] = useState(false);
  const [newDetail, setNewDetail] = useState(null);
  const [editDropdownsModalOpen, setEditDropdownsModalOpen] = useState(false);
  const [isIndustryType, setIsIndustryType] = useState(false);
  const [isAnnualTurnover, setIsAnnualTurnover] = useState(false);
  const [isCompanyType, setIsCompanyType] = useState(false);
  const isCompany = user?.userTypeId === USERTYPE_ID.ENTITY;

  useEffect(() => {
    dispatch(getInvestorDetailsByOrgId(user?.orgId));
  }, [dispatch, user.orgId]);

  const handleDetailEdit = (detail) => {
    setOldDetailOtpModalOpen(true);

    const payload = {
      email: investorData?.email,
    };

    if (detail === "phone") {
      setIsMobileOtp(true);
      delete payload.email;
      payload.mobile = investorData?.contactPhoneNumber;
    }

    dispatch(sendOtp(payload));
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="investor-details-container">
          <div className="header-container">
            <Title level={4}>
              {isCompany ? TITLE_TXT.COMP_DETS : TITLE_TXT.NBFC_DETS}
            </Title>
          </div>
          <div className="details-container">
            <ProfileDetail
              label={
                isCompany
                  ? GLOBAL_CONSTANTS.COMP_NAME
                  : GLOBAL_CONSTANTS.NBFC_NAME
              }
              value={investorData?.busName}
            />

            <ProfileDetail
              label={
                isCompany
                  ? GLOBAL_CONSTANTS.COMP_EMAIL
                  : GLOBAL_CONSTANTS.NBFC_EMAIL
              }
              value={
                showEmail ? investorData?.email : maskEmail(investorData?.email)
              }
              isVerified={investorData?.isEmailVerified}
              showValue={showEmail}
              setShowValue={setShowEmail}
              onEdit={() => handleDetailEdit("email")}
              isMasked
              isEditable
            />

            <ProfileDetail
              label={
                isCompany
                  ? GLOBAL_CONSTANTS.COMP_PH_NUM
                  : GLOBAL_CONSTANTS.NBFC_PH_NUM
              }
              value={`+91 ${
                showPhone
                  ? investorData?.contactPhoneNumber
                  : maskPhone(investorData?.contactPhoneNumber)
              }`}
              isVerified={investorData?.isPhoneNumberVerified}
              showValue={showPhone}
              setShowValue={setShowPhone}
              onEdit={() => handleDetailEdit("phone")}
              isMasked
              isEditable
            />

            <ProfileDetail
              label={GLOBAL_CONSTANTS.IND_TYPE}
              value={
                capitalizeWords(investorData?.industryTypeName) ||
                GLOBAL_CONSTANTS.NA
              }
              onEdit={() => {
                setEditDropdownsModalOpen(true);
                setIsIndustryType(true);
              }}
              isEditable
            />

            {isCompany && (
              <ProfileDetail
                label={GLOBAL_CONSTANTS.COMP_TYPE}
                value={
                  capitalizeWords(investorData?.entityTypeName) ||
                  GLOBAL_CONSTANTS.NA
                }
                onEdit={() => {
                  setEditDropdownsModalOpen(true);
                  setIsCompanyType(true);
                }}
                isEditable
              />
            )}

            <ProfileDetail
              label={GLOBAL_CONSTANTS.ANN_TURN}
              value={
                capitalizeWords(investorData?.annualTurnoverName) ||
                GLOBAL_CONSTANTS.NA
              }
              onEdit={() => {
                setEditDropdownsModalOpen(true);
                setIsAnnualTurnover(true);
              }}
              isEditable
            />

            <ProfileDetail
              label={
                isCompany
                  ? GLOBAL_CONSTANTS.COMP_REG_ADD
                  : GLOBAL_CONSTANTS.NBFC_REG_ADD
              }
              value={
                [
                  investorData?.primaryAddLine1,
                  investorData?.primaryAddLine2,
                  investorData?.primaryCityName,
                  investorData?.primaryDistrictName,
                  investorData?.primaryStateName,
                  investorData?.primaryCountryName,
                  investorData?.primaryZipCode,
                ]
                  .filter(Boolean)
                  .join(", ") || GLOBAL_CONSTANTS.NA
              }
            />
          </div>
          <div
            className="header-container"
            style={{ borderTop: "1px solid #e3eaf3" }}
          >
            <Title level={4}>{TITLE_TXT.AUTH_SIG}</Title>
          </div>
          <div className="details-container">
            <ProfileDetail
              label={GLOBAL_CONSTANTS.DIR_NAME}
              value={investorData?.contactName}
            />

            <ProfileDetail
              label={GLOBAL_CONSTANTS.DESIG}
              value={
                capitalizeWords(investorData?.designationName) ||
                GLOBAL_CONSTANTS.NA
              }
            />

            <ProfileDetail
              label={GLOBAL_CONSTANTS.DOB}
              value={investorData?.dob || GLOBAL_CONSTANTS.NA}
            />

            <ProfileDetail
              label={GLOBAL_CONSTANTS.DIR_EMAIL}
              value={
                showEmail ? investorData?.email : maskEmail(investorData?.email)
              }
              isVerified={investorData?.isEmailVerified}
              showValue={showEmail}
              setShowValue={setShowEmail}
              onEdit={() => handleDetailEdit("email")}
              isMasked
              isEditable
            />

            <ProfileDetail
              label={GLOBAL_CONSTANTS.DIR_PH_NUM}
              value={`+91 ${
                showPhone
                  ? investorData?.contactPhoneNumber
                  : maskPhone(investorData?.contactPhoneNumber)
              }`}
              isVerified={investorData?.isPhoneNumberVerified}
              showValue={showPhone}
              setShowValue={setShowPhone}
              onEdit={() => handleDetailEdit("phone")}
              isMasked
              isEditable
            />
          </div>
          {oldDetailOtpModalOpen && (
            <CustomModal
              open={oldDetailOtpModalOpen}
              centered
              maskClosable={false}
              onCancel={() => {
                setOldDetailOtpModalOpen(false);
                setIsMobileOtp(false);
              }}
              content={
                <OtpContent
                  oldDetailOtpModalOpen={oldDetailOtpModalOpen}
                  onClose={() => setOldDetailOtpModalOpen(false)}
                  setNewDetailModalOpen={setNewDetailModalOpen}
                  isMobileOtp={isMobileOtp}
                  oldDetail={
                    isMobileOtp
                      ? investorData?.contactPhoneNumber
                      : investorData?.email
                  }
                />
              }
            />
          )}
          {newDetailModalOpen && (
            <CustomModal
              open={newDetailModalOpen}
              centered
              maskClosable={false}
              onCancel={() => {
                setNewDetailModalOpen(false);
                setIsMobileOtp(false);
              }}
              content={
                <NewEmailPhoneContent
                  onClose={() => setNewDetailModalOpen(false)}
                  setNewDetailOtpModalOpen={setNewDetailOtpModalOpen}
                  setNewDetail={setNewDetail}
                  isMobileOtp={isMobileOtp}
                />
              }
            />
          )}
          {newDetailOtpModalOpen && (
            <CustomModal
              open={newDetailOtpModalOpen}
              centered
              maskClosable={false}
              onCancel={() => {
                setNewDetailOtpModalOpen(false);
                setIsMobileOtp(false);
              }}
              content={
                <OtpContent
                  newDetail={newDetail}
                  setNewDetail={setNewDetail}
                  newDetailOtpModalOpen={newDetailOtpModalOpen}
                  setNewDetailModalOpen={setNewDetailModalOpen}
                  onClose={() => setNewDetailOtpModalOpen(false)}
                  isMobileOtp={isMobileOtp}
                />
              }
            />
          )}
          {editDropdownsModalOpen && (
            <CustomModal
              open={editDropdownsModalOpen}
              centered
              maskClosable={false}
              onCancel={() => {
                setEditDropdownsModalOpen(false);
                setIsAnnualTurnover(false);
                setIsIndustryType(false);
                setIsCompanyType(false);
              }}
              content={
                <EditDropdownsForm
                  industry={investorData?.industryTypeId}
                  annualTurnover={investorData?.annualTurnoverId}
                  company={investorData?.entityTypeId}
                  isIndustry={isIndustryType}
                  isAnnualTurnover={isAnnualTurnover}
                  isCompanyType={isCompanyType}
                  setEditDropdownsModalOpen={setEditDropdownsModalOpen}
                  setIsAnnualTurnover={setIsAnnualTurnover}
                  setIsIndustryType={setIsIndustryType}
                  setIsCompanyType={setIsCompanyType}
                />
              }
            />
          )}
        </div>
      )}
    </>
  );
};

export default CompanyDetails;
